import { useMutation, useQuery, useQueryClient, } from "@tanstack/react-query";
import { API, actionDeleteAPI, actionGetAPI, actionPostAPI } from "controllers/Api.controller";
    
export const useAuth = () => {
    const queryClient = useQueryClient();

    const resolveUnauthorizedSession = (resolve, reject) => (error) => {
        const status = error?.response?.status || error?.status;
        if (status === 401) {
            resolve(null);
            return;
        }
        reject(error);
    };

    const auth = useQuery({
        queryKey: ['login'],
        queryFn: () => {
            return new Promise((resolve, reject) => {
                actionGetAPI(API.AUTH, "signin", resolve, resolveUnauthorizedSession(resolve, reject));
            });
        },
        staleTime: 120000,
        placeholderData : undefined,
    })

    const login = useMutation({
        mutationFn : (login: any) => {
            return new Promise((resolve, reject) => {
                // console.log("login");
                actionPostAPI(API.AUTH, "signin", login, resolve, reject);
            })
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['login'] });
        }
    })

    const logout = useMutation({
        mutationFn : () => {
            return new Promise((resolve, reject) => {
                // console.log("logout");
                actionDeleteAPI(API.AUTH, "signin", resolve, reject);
            })
        },
        onSuccess: () => {
            queryClient.removeQueries();
        }
    })

    return {
        auth,
        login,
        logout
    }
}